import { Area, PrstTxWarp } from '../../../type/common.interface';
import { getFuncSine } from '../../utils/get-func-sine';

export function textWave4(prstTxWarp: PrstTxWarp, area: Area) {
    const bottomLine = (x: number) => {
        const a = area.height / 8;
        const e = area.height / 8;
        const b = Math.PI / (area.width / 4);
        const p = 0;

        return getFuncSine(x, a, e, b, p);
    };

    const topLine = (x: number) => {
        const a = area.height / 8;
        const e = area.height * 7 / 8;
        const b = Math.PI / (area.width / 4);
        const p = 0;

        return getFuncSine(x, a, e, b, p);
    };

    return [
        bottomLine,
        topLine,
    ];
}
